module.exports = __webpack_public_path__ + "static/media/J2.1f20f9c5.jpg";